import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LngAdvancedSettingsComponent } from './lng-advanced-settings.component';
import { CustomModule } from 'angular/custom/custom.module';
import { FormsModule } from '@angular/forms';
import { LngAdminPrismaCreditLimitCheckComponent } from './lng-admin-prisma-credit-limit-check.component';
import { CollapseModule } from 'ngx-bootstrap';
import { LngAdminPrismaCreditLimitCheckFormComponent } from './lng-admin-prisma-credit-limit-check-form.component';
import { LngPeriodTypePickerComponent } from './lng-period-type-picker.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CustomModule,
        FormsModule,
        CollapseModule
    ],
    exports: [
        LngAdvancedSettingsComponent,
        LngAdminPrismaCreditLimitCheckComponent
    ],
    declarations: [
        LngAdvancedSettingsComponent,
        LngAdminPrismaCreditLimitCheckComponent,
        LngAdminPrismaCreditLimitCheckFormComponent,
        LngPeriodTypePickerComponent
    ],
    entryComponents: [
        LngAdvancedSettingsComponent,
        LngAdminPrismaCreditLimitCheckComponent
    ]
})
export class LngModule {}
